import { GenericExperienceFe } from "@intelligems/ig-types";
import {
  getEndedAtTs,
  getPausedAtTs,
  getStartedAtTs,
} from "@intelligems/ig-utils";

export const getExperienceStatusText = (experience: GenericExperienceFe) => {
  switch (experience.status) {
    case "pending":
      return "Created";
    case "started":
      return "Started";
    case "paused":
      return "Paused";
    case "ended":
      return "Ended";
    default:
      return "";
  }
};

export const getExperienceStatusDate = (experience: GenericExperienceFe) => {
  switch (experience.status) {
    case "started":
      return getStartedAtTs(experience.experienceActions || [])?.actionTs;
    case "paused":
      return getPausedAtTs(experience.experienceActions || [])?.actionTs;
    case "ended":
      return getEndedAtTs(experience.experienceActions || [])?.actionTs;
    default:
      return experience.createdAtTs;
  }
};
